// extracted by mini-css-extract-plugin
export default {"root":"ViewerPdf__root--6QMDH","root_menu":"ViewerPdf__root_menu--JK2Cv","root_fillParent":"ViewerPdf__root_fillParent--3RRK3","pdf":"ViewerPdf__pdf--rN2-Z"};